import { nanoid } from "nanoid";

const NODE_ID_SIZE = 6;

export const idGenerator = () => nanoid(NODE_ID_SIZE);
